import React, { ReactElement, useState } from 'react';

import { Flex, Box, Row, Col, Typography } from 'components';

import Term from './Term2';
import Form from './Form';
import packs from './packs-mentoria';

import { Wrapper, ContentWrapper, Square, Square2, PacoteWrapper } from './styles';
import { createMarkup } from 'app/utils';

const Imersao = (): ReactElement => {
  const currentPack = packs[0];
  const currentPlan = currentPack.pagamentos[0];

  const [optin, setOptin] = useState(false);
  const [showTerm, setShowTerm] = useState(false);

  return (
    <>
      {showTerm && <Term optin={optin} setOptin={setOptin} showTerm={showTerm} setShowTerm={setShowTerm} />}

      <Wrapper>
        <ContentWrapper>
          <img src="/images/cover-pagamento.png" alt="Mentoria" />
        </ContentWrapper>

        <ContentWrapper>
          <Row gutter={20} mt={{ d: 70 }}>
            <Col width={{ d: 2 / 3 }} mx={{ m: 20, d: 0 }} mt={{ m: 40, d: 0 }}>
              <Flex flexDirection="column" flexGrow={1} bg="gray_600">
                <Box bg="dark_150" position="relative" pt={26} pb={30} px={20} flexGrow={1}>
                  <Square2 />

                  <Box mt="10px">
                    <Typography type="type5" color="white" fontWeight="light" upper>
                      Dados de pagamento
                    </Typography>
                  </Box>

                  <Box mt="10px">
                    <Typography type="type0" color="white">
                      Informações de cadastro e pagamento
                    </Typography>
                  </Box>
                </Box>

                <Box p={20}>
                  <Form optin={optin} setOptin={setOptin} showTerm={showTerm} setShowTerm={setShowTerm} />
                </Box>
              </Flex>
            </Col>

            <Col width={{ d: 1 / 3 }} mx={{ m: 20, d: 0 }} mt={{ m: 40, d: 0 }}>
              <Box>
                <Box minHeight={{ d: 220 }} position="relative" pt={66} pb={40} px={20} flexGrow={1} bg="#2A2C2B">
                  <Square />

                  <Box mt="10px">
                    <Typography type="type2" color="white" upper>
                      {currentPack.hat}
                    </Typography>

                    <Typography type="type5" color="white" fontWeight="bold">
                      {currentPack.name}
                    </Typography>
                  </Box>

                  {Boolean(currentPack.description) && (
                    <Box mt="5px">
                      <Typography lineHeight="1.4" type="type0" color="white" dangerouslySetInnerHTML={createMarkup(currentPack.description)} />
                    </Box>
                  )}
                </Box>

                <Box bg="#1D1F1E">
                  <PacoteWrapper p={20}>
                    <Typography type="type3" fontWeight="bold" color="white">
                      {currentPlan.valor}
                    </Typography>

                    {Boolean(currentPlan.parcelas) && (
                      <Box mt="3px">
                        <Typography type="type1" color="white">
                          {currentPlan.parcelas}
                        </Typography>
                      </Box>
                    )}

                    <Box mt="15px">
                      <Typography lineHeight="1.3" type="type0" color="white25">
                        {currentPlan.descricao}
                      </Typography>
                    </Box>
                  </PacoteWrapper>
                </Box>
              </Box>
            </Col>
          </Row>

          <Box flexGrow={1} textAlign="center" pt={{ m: 40, d: 100 }} pb="20px">
            <Typography lineHeight="1.4" type="type0" color="#9F9F9F">
              © Todos os direitos reservados a Raony Rossetti
            </Typography>
          </Box>
        </ContentWrapper>
      </Wrapper>
    </>
  );
};
export default Imersao;
